export const bytesToMB = bytes => {
  const kb = 1024;
  return +(bytes / kb / kb).toFixed(2);
};
